
import preferredLanesTypes from './preferredLanesTypes'

export const getPreferredLanes = () => ({
  type: preferredLanesTypes.GET_PREFERRED_LANES
})

export const getPreferredLanesSuccess = (payload) => ({
  type: preferredLanesTypes.GET_PREFERRED_LANES_SUCCESS,
  payload
})

export const getPreferredLanesFailure = (payload) => ({
  type: preferredLanesTypes.GET_PREFERRED_LANES_FAILURE,
  payload
})

export const addPreferredLane = (payload, callback) => ({
  type: preferredLanesTypes.ADD_PREFERRED_LANE,
  payload,
  callback
})

export const addPreferredLaneSuccess = (payload) => ({
  type: preferredLanesTypes.ADD_PREFERRED_LANE_SUCCESS,
  payload
})

export const addPreferredLaneFailure = (payload) => ({
  type: preferredLanesTypes.ADD_PREFERRED_LANE_FAILURE,
  payload
})

export const updatePreferredLane = (payload, callback) => ({
  type: preferredLanesTypes.UPDATE_PREFERRED_LANE,
  payload,
  callback
})

export const updatePreferredLaneSuccess = (payload) => ({
  type: preferredLanesTypes.UPDATE_PREFERRED_LANE_SUCCESS,
  payload
})

export const updatePreferredLaneFailure = (payload) => ({
  type: preferredLanesTypes.UPDATE_PREFERRED_LANE_FAILURE,
  payload
})

export const deletePreferredLane = (payload, callback) => ({
  type: preferredLanesTypes.DELETE_PREFERRED_LANE,
  payload,
  callback
})

export const deletePreferredLaneSuccess = (payload) => ({
  type: preferredLanesTypes.DELETE_PREFERRED_LANE_SUCCESS,
  payload
})

export const deletePreferredLaneFailure = (payload) => ({
  type: preferredLanesTypes.DELETE_PREFERRED_LANE_FAILURE,
  payload
})
